import React from "react";

/**
 * Toggle / Switch
 * @param {boolean}  checked
 * @param {function} onChange  - recibe el nuevo valor boolean
 * @param {string}   label
 * @param {"primary"|"secondary"|"accent"|"success"|"warning"|"error"} color
 * @param {boolean}  disabled
 */
export default function Toggle({
    checked = false,
    onChange,
    label,
    color = "primary",
    disabled = false,
}) {
    const colorMap = {
        primary:   "bg-primary",
        secondary: "bg-secondary",
        accent:    "bg-accent",
        success:   "bg-success",
        warning:   "bg-warning",
        error:     "bg-error",
    };

    const trackActive   = colorMap[color] ?? colorMap.primary;
    const trackInactive = "bg-base-300";

    return (
        <label
            className={`inline-flex items-center gap-3 select-none ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}
        >
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                disabled={disabled}
                onClick={() => !disabled && onChange?.(!checked)}
                className={`
                    relative w-11 h-6 rounded-full transition-colors duration-200 outline-none
                    overflow-hidden
                    focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary
                    ${checked ? trackActive : trackInactive}
                `}
            >
                <span
                    className={`
                        absolute top-1 left-0 w-4 h-4 bg-white rounded-full shadow-sm
                        transition-transform duration-200
                        ${checked ? "translate-x-6" : "translate-x-1"}
                    `}
                />
            </button>
            {label && (
                <span className="text-sm dark:text-gray-200 text-gray-700">{label}</span>
            )}
        </label>
    );
}
